import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/**
* THIS IS AN AUTO GENERATED FILE, CHANGES WILL NOT APPLY
*/

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.823 7.783L9 8.46V1.083a1 1 0 012 0V8.46l1.178-.677a.867.867 0 01.864 1.503l-2.543 1.463a1.002 1.002 0 01-.997 0L6.958 9.286a.867.867 0 01.865-1.503M15 18c-.551 0-1-.449-1-1 0-1.322 2-1.322 2 0 0 .551-.448 1-1 1M3 18c-.551 0-1-.449-1-1 0-1.322 2-1.322 2 0 0 .551-.448 1-1 1M19 0h-3c-1 0-2 .661-2 2.375V12H4V7c0-2.005 3 .004 3-2a1 1 0 00-1-1H4a2 2 0 00-2 2v8.183a2.991 2.991 0 00-1.941 3.416A3.002 3.002 0 006 17a2.992 2.992 0 00-2-2.817V14h10v.183a2.991 2.991 0 00-1.941 3.416A3.002 3.002 0 0018 17a2.992 2.992 0 00-2-2.817C16 .696 15.008 2 19 2a1 1 0 100-2",
  fillRule: "evenodd"
});

var CartDownRoundIcon = function CartDownRoundIcon(_ref) {
  var className = _ref.className,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["className", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    className: className,
    style: {
      width: size * 10,
      height: size * 10
    },
    fill: "undefined",
    focusable: "false"
  }, rest), _ref2);
};

process.env.NODE_ENV !== "production" ? void 0 : void 0;
CartDownRoundIcon.defaultProps = {
  size: 1.5
};
export default CartDownRoundIcon;